import VerifyPhoneForm from '@/components/auth/VerifyPhoneForm'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

const VerifyPhone = () => {
  return (
    <Card className="w-full max-w-md">
      <CardHeader>
        <CardTitle className="text-2xl">Verify Phone</CardTitle>
      </CardHeader>
      <CardContent>
        <VerifyPhoneForm />
      </CardContent>
    </Card>
  )
}

export default VerifyPhone